import { useQuery } from '@tanstack/react-query';
import { useAuthUserId } from '../../../../selectors/AuthSelectors';
import { useRestaurantId } from '../../../../selectors/RestaurantSelectors';
import { getAllTablesRequest } from '../api/api';
import { AllTablesDTO } from './types';

export const getMaxCapacity = (tables: AllTablesDTO[]) => {
  return tables.reduce((max, table) => Math.max(max, table.capacity), 0);
};

export function useAllTablesQueryKey() {
  return [useAuthUserId(), 'allTables', useRestaurantId()];
}

export function useAllTables() {
  const restaurantId = useRestaurantId();

  const { data, isLoading, isError } = useQuery({
    staleTime: 60 * 1000 * 5,
    refetchOnWindowFocus: false,
    enabled: !!restaurantId,
    queryKey: useAllTablesQueryKey(),
    queryFn: () => (restaurantId ? getAllTablesRequest(restaurantId) : undefined),
    select: (response) => (response?.data ? response.data : []),
  });

  return {
    isLoading,
    isError,
    data,
  };
}
